import { selectIsInternalAdmin } from 'accessors'
import ServiceHistoryDialog from 'components/ReusableComponents/ServiceHIstoryDialog'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import AddServiceDialog from '../../../components/ReusableComponents/AddServiceDialog/index'
import EditServiceDialog from '../../../components/ReusableComponents/EditServiceDialog/index'
import { USCurrency } from '../../../components/ReusableComponents/FormattedPrice/index'
import {
  directfulServiceNames,
  directfulServiceTypes
} from '../../../main/directfulServices'
import Box from '../Box/index'
import { ReactComponent as Chevron } from './chevron.svg'
import { ReactComponent as HistoryIcon } from './history.svg'
import { ReactComponent as PlusIcon } from './plus.svg'
import styles from './Services.module.scss'

const Services = ({ billingTaxRate, subscriptions, status }) => {
  const [showAddDialog, setShowAddDialog] = useState()
  const [editedSubscription, setEditedSubscription] = useState()
  const [showHistoryDialog, setShowHistoryDialog] = useState(false)

  const canGetMoreServices =
    status === 'Paused'
      ? false
      : subscriptions.map(s => s.plan).length < Object.keys(directfulServiceNames).length

  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  return (
    <>
      {showAddDialog && (
        <AddServiceDialog
          currentServices={subscriptions}
          handleClose={() => setShowAddDialog(false)}
          billingTaxRate={billingTaxRate}
        />
      )}
      {editedSubscription && (
        <EditServiceDialog
          handleClose={() => setEditedSubscription(null)}
          service={editedSubscription}
          billingTaxRate={billingTaxRate}
        />
      )}
      {showHistoryDialog && (
        <ServiceHistoryDialog
          onClose={() => setShowHistoryDialog(false)}
          subscriptions={subscriptions}
        />
      )}
      <Box className={styles.box}>
        <div className={styles.content}>
          <div className={styles.title}>
            <span>Services &amp; fees</span>
            {canGetMoreServices && isInternalAdmin && (
              <button onClick={() => setShowAddDialog(true)}>
                <PlusIcon />
              </button>
            )}
          </div>
          {Object.keys(directfulServiceTypes).map(serviceType =>
            subscriptions.find(s => s.plan === serviceType) ? (
              <Row
                {...subscriptions.find(s => s.plan === serviceType)}
                key={serviceType}
                handleClick={() =>
                  setEditedSubscription(subscriptions.find(s => s.plan === serviceType))
                }
                isClickable={status === 'Paused' ? false : isInternalAdmin}
              />
            ) : null
          )}
          {subscriptions.length === 0 && (
            <div className={styles.errorText}>No active services</div>
          )}
        </div>
        <button
          className={styles.showHistoryButton}
          onClick={() => setShowHistoryDialog(true)}
        >
          <HistoryIcon />
          Show history
        </button>
      </Box>
    </>
  )
}

const Row = ({
  plan,
  planRate,
  isFlatMonthly = true,
  handleClick,
  isClickable,
  startDate,
  endDate,
  isActive
}) => {
  return (
    <div
      onClick={isClickable ? handleClick : undefined}
      className={isClickable ? styles.rowClickable : styles.row}
    >
      <div>
        <span className={styles.planName}>{directfulServiceNames?.[plan] || plan}</span>
        <p className={styles.startDate}>
          {isActive ? (
            <>
              <span className={styles.active}>Active</span>
              &nbsp;since {moment(startDate).format('MMM D, YYYY')}
            </>
          ) : (
            <>
              <span className={styles.disabled}>Disabled</span> on{' '}
              {moment(endDate).format('MMM D, YYYY')}
            </>
          )}
        </p>
      </div>
      <span className={styles.planRate}>
        {isFlatMonthly ? <USCurrency>{planRate}</USCurrency> : <>%{planRate}</>}
      </span>
      <Chevron />
    </div>
  )
}

export default Services
